import React from 'react'
import HeaderText  from './HeaderText'
import ApplyNow  from './ApplyNow'
import HeaderImage  from './HeaderImage'

const HomeHeader = () => (
  <div className="jumbotron jumbotron-fluid jumbotron-fixed-height yard-hero mb-5 home-header-container">
    <div className="left-header-container">
      <HeaderText />
      <ApplyNow />
    </div>
    <HeaderImage />
  </div>
);

export default HomeHeader
